import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { enUS, ro, fr, sk } from 'date-fns/locale';

import { MAP_LOCALE_TO_DATE_FNS_LOCALE } from '../constants';

const localeMap = {
  'ro': ro,
  'en-US': enUS,
  'fr': fr,
  'sk': sk,
};
export default function useSelectedLocale() {

  const { i18n } = useTranslation();
  const localeCode = (MAP_LOCALE_TO_DATE_FNS_LOCALE[i18n.language] || 'en-US') as keyof typeof localeMap;

  // Compute the locale synchronously, falling back to enUSLocale if not in the map
  const selectedLocale = useMemo(() => {
    return localeMap[localeCode] || enUS;
  }, [localeCode]);

  return selectedLocale;
}
